import { Box, ContainerProps, SxProps, Theme } from '@mui/material';
import { CenterContainer } from '@/components/blocks/CenterContainer';

interface DpContainerProps extends ContainerProps {
	framesx?: SxProps<Theme>;
	sx?: SxProps<Theme>;
	benefitGray?: boolean;
	isPopulate?: boolean;
	nocontainer?: boolean;
}

export const DpBottomContainer: React.FC<React.PropsWithChildren<DpContainerProps>> = ({
	children,
	component,
	framesx,
	sx = {},
	benefitGray,
	isPopulate,
	nocontainer,
	...props
}) => {
	if (nocontainer) {
		return (
			<Box
				sx={[
					{
						padding: {
							xs: isPopulate ? 'var(--spacing-8) 0' : 'var(--spacing-5) 0',
							sm: benefitGray ? 'var(--spacing-5) 0' : 'var(--spacing-8) 0',
						},
					},
					...(Array.isArray(sx) ? sx : [sx]),
				]}
			>
				{children}
			</Box>
		);
	}
	return (
		<Box component={component} width="100vw" display="flex" justifyContent="center" sx={framesx}>
			<CenterContainer
				sx={[
					{
						padding: {
							xs: isPopulate ? 'var(--spacing-8) 0' : 'var(--spacing-5) 0',
							sm: benefitGray ? 'var(--spacing-5) 0' : 'var(--spacing-8) 0',
						},
					},
					...(Array.isArray(sx) ? sx : [sx]),
				]}
				{...props}
			>
				{children}
			</CenterContainer>
		</Box>
	);
};
